
var AST = {}

AST.NODETYPE_NUMBER = 1;
AST.NODETYPE_DATE = 2;
AST.NODETYPE_IDENT = 3;
AST.NODETYPE_FUNCTION = 4;
AST.NODETYPE_BINARY = 5;

AST.OP_AND = 1;
AST.OP_OR = 2;
AST.OP_EQ = 3;
AST.OP_NE = 4;
AST.OP_LT = 5;
AST.OP_LE = 6;
AST.OP_GT = 7;
AST.OP_GE = 8;
AST.OP_ADD = 10;
AST.OP_SUB = 11;
AST.OP_MUL = 12;
AST.OP_DIV = 13;



class ASTNode {
  constructor(type) {
    this.nodeType = type;
  }
}



class ASTExpression extends ASTNode {
  constructor(type) {
    super(type);
  }
}



class ASTDate extends ASTExpression {
  constructor(val) {
    super(AST.NODETYPE_DATE);

    this.dateVal = val;
  }

}


class ASTNumber extends ASTExpression {
  constructor(val) {
    super(AST.NODETYPE_NUMBER);

    this.numVal = val;
  }

}



class ASTIdentifier extends ASTExpression {
  constructor(val) {
    super(AST.NODETYPE_IDENT);

    this.ident = val;
  }

}


class ASTFunction extends ASTExpression {
  constructor(name) {
    super(AST.NODETYPE_FUNCTION);

    this.funcName = name;
    this.params = [];
  }
  
}


class ASTBinary extends ASTExpression {
  constructor(type, left, right) {
    super(AST.NODETYPE_BINARY);

    this.type = type;
    this.left = left;
    this.right = right;
  }

}



export { 
  AST, 
  ASTNode, 
  ASTExpression, 
  ASTNumber, 
  ASTDate, 
  ASTIdentifier, 
  ASTFunction,
  ASTBinary,
};




